import React, { useEffect, useState } from "react";
import { Button, Modal, Alert, Row, Col, Table } from "react-bootstrap";
import ApiManager from "../utils/ApiManager"; // Adjust the path as per your directory structure
import "./Modal.css";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import RowCountLabel from "./RowCountLabel";
import DataManager from "../utils/DataManager";
import ProductLink from "./ProductLink";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import ErrorIcon from "@mui/icons-material/Error";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const ModalEditOutgoings = ({
  pickingListId,
  movements,
  showModal,
  onCloseModal,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState("");
  const [pickingList, setPickingList] = useState([]);
  const [quantities, setQuantities] = useState({});

  useEffect(() => {
      if (showModal) {
        setValidationError("");
        fetchData();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  useEffect(() => {
    const tmpQuantities = Object.fromEntries(
      Object.entries(quantities).map(([key, item]) => [
        key,
        { ...item, selectedQty: 0, isValid: false },
      ])
    );

    pickingList.forEach((row) => {
      row.pickingList.forEach((item) => {
        tmpQuantities[item.keyId].selectedQty += item.selectedQty;
      });
    });
    setQuantities(tmpQuantities);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickingList]);

  // useEffect(() => {
  //   console.log("Quantities aggiornato", quantities);
  // }, [quantities]);

  const getItemId = (item) => {
    return `${item.productId}-${item.warehouseAreaId}-${item.rack}-${item.col}-${item.shelf}-${item.productYear}-${item.supplierId}`;
  };

  const fetchData = () => {
    setError(null);
    ApiManager.Top.cellProducts(
      {
        pickingListId: pickingListId,
        pickingList: movements
          // ?.filter((row) => row.selected)
          .map((row) => ({
            productId: row.productId,
            qty: row.qty,
          })),
      },
      (data) => {
        // let tmpPickingList = movements
        //   // ?.filter((row) => row.selected)
        //   ?.map((row) => ({
        //     ...row,
        //     pickingList: data?.filter(
        //       (item) => item.productId === row.productId && item.id !== row.id
        //     ),
        //   }));
        movements.forEach((row) => {
          const item = data.find(
            (item) =>
              item.productId === row.productId &&
              item.warehouseAreaId === row.warehouseAreaId &&
              item.rack === row.rack &&
              item.col === row.col &&
              item.shelf === row.shelf &&
              item.productYear === row.productYear &&
              item.supplierId === row.supplierId
          );

          if (item) {
            item.qty += row.qty;
            item.selectedQty = item.qty;
          } else {
            data.push({
              warehouseAreaId: row.warehouseAreaId,
              warehouseAreaDescr: row.warehouseAreaDescr,
              rack: row.rack,
              col: row.col,
              shelf: row.shelf,
              productTypeId: row.productTypeId,
              productTypeDescr: row.productTypeDescr,
              productId: row.productId,
              productEan: row.productEan,
              productSupplCode: row.productSupplCode,
              productDescr: row.productDescr,
              productYear: row.productYear,
              supplierId: row.supplierId,
              supplierDescr: row.supplierDescr,
              qty: row.qty,
              selectedQty: row.qty,
            });
          }
        });

        const tmpQuantities = {};
        data?.map((row) => {
          let result = { ...row, keyId: getItemId(row) };
          if (!tmpQuantities[result.keyId]) {
            tmpQuantities[result.keyId] = { qty: 0 };
          }
          tmpQuantities[result.keyId].qty += result.qty;
          return result;
        });

        const tmpPickingList = movements?.map((row) => {
          const filteredItems =
            data 
            ?.filter(
              (item) => item.productId === row.productId && item.id !== row.id
            ) ||
            [];

          let result = {
            ...row,
            keyId: getItemId(row),
            pickingList: filteredItems.map((item) => ({
              ...item,
              keyId: getItemId(item),
              selectedQty:
                item.productId === row.productId &&
                item.warehouseAreaId === row.warehouseAreaId &&
                item.rack === row.rack &&
                item.col === row.col &&
                item.shelf === row.shelf &&
                item.productYear === row.productYear &&
                item.supplierId === row.supplierId
                  ? row.qty
                  : 0,
            })),
          };
          return result;
        });

        tmpPickingList.map((row) => {
          row.pickingList = row.pickingList.map((item) => {
            let result = {
              ...item,
              qty: tmpQuantities[item.keyId].qty,
            };
            return result;
          });

          return row;
        });

        setQuantities(tmpQuantities);
        setPickingList(tmpPickingList);
      },
      (error) => {
        setError(error);
      },
      () => {}
    );
  };

  const handleCloseModal = () => {
    onCloseModal(false);
  };

  const validateFields = () => {
    // Implement your validation logic here if needed
    return "";
  };

  const handlePickingListQtyChange = (index, pickingListIndex, event) => {
    let newData = [...pickingList]; // Copia il pickingList originale
    let selectedQty = parseInt(event.target.value, 10) || 0; // Ottieni la nuova quantità selezionata

    // Aggiorna la quantità selezionata per la riga specifica
    newData[index].pickingList[pickingListIndex].selectedQty = selectedQty;

    // Aggiorna lo stato con la lista aggiornata
    setPickingList(newData);
  };

  const handleDeleteRow = (rowId) => {
    const updatedRows = pickingList.filter((row) => row.id !== rowId);
    setPickingList(updatedRows);
  };

  const handleSaveModal = () => {
    const error = validateFields();
    if (error) {
      setValidationError(error);
      return;
    }

    const outgoings = pickingList;

    ApiManager.Top.stockOutgoings(
      pickingListId,
      outgoings,
      (data) => {
        handleCloseModal();
      },
      (error) => {
        console.error("Error during API call:", error);
        setValidationError("Errore durante il salvataggio. Riprova.");
      },
      () => {}
    );
  };

  return (
    <Modal
      className="incomingModals"
      show={showModal}
      onHide={handleCloseModal}
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <strong className="header-text">Scarico</strong>
      </Modal.Header>
      <Modal.Body>
        {validationError && <Alert variant="danger">{validationError}</Alert>}
        <Row className="mb-3">
          <Col>
            <RowCountLabel
              count={pickingList?.length}
              label="Articoli da scaricare"
            />
            <Table striped>
              <thead>
                <tr>
                  <th style={{ width: "64px" }}></th>
                  <th>Documento</th>
                  <th>Articolo</th>
                  <th>Cliente</th>
                  <th>Fornitore</th>
                  <th className="text-end" style={{ width: "100px" }}>
                    Anno
                  </th>
                  <th className="text-end" style={{ width: "170px" }}>
                    Qta
                  </th>
                  <th>Ubicazione</th>
                </tr>
              </thead>
              <tbody>
                {pickingList
                  ?.filter(
                    (row) => !row.pickingList.some((item) => item.selectedQty < 0)
                  )
                  ?.map((row, rowIndex) => (
                    <React.Fragment key={`row-${row.id}`}>
                      <tr
                        style={{ verticalAlign: "middle", fontWeight: "bold" }}
                      >
                        <td className="text-center">
                          <Button
                            title="Elimina"
                            variant="danger"
                            onClick={() => handleDeleteRow(row.id)}
                            className="float-end"
                          >
                            <DeleteForeverIcon />
                          </Button>
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>
                              {row.docTypeDescr}&nbsp;
                              {row.docNumb}
                              {row.docSeries?.trim() ? "/" + row.docSeries : ""}
                              &nbsp;
                              {DataManager.Date.format(
                                row.docDate,
                                "dd/MM/yyyy"
                              )}
                              {/* <span className="half-parent-text">&nbsp;{row.id}</span> */}
                            </li>
                            <li>
                              <span className="half-parent-text">
                                {row.transpReasonDescr}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ProductLink {...row} showProductLink={false} />
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>{row.customerDescr}</li>
                            <li>
                              <span className="half-parent-text">
                                {row.customerId}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td></td>
                        <td className="text-end"></td>
                        <td className="text-end">
                          <div className="d-flex justify-content-between align-items-center">
                            {
                              //row.pickingList &&
                              // (row.pickingList?.reduce(
                              //   (sum, mov) => sum + mov.selectedQty,
                              //   0
                              // )

                              row.pickingList &&
                                (row.pickingList?.reduce(
                                  (sum, mov) => sum + mov.selectedQty,
                                  0
                                ) === row.qty ? (
                                  <CheckCircleIcon className="me-3 text-success" />
                                ) : (
                                  <WarningIcon className="me-3 text-warning" />
                                ))
                            }
                            {row.noStock && <FiberNewIcon />}
                            {DataManager.Decimal.format(row.qty, 0)}
                          </div>
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>
                              {row.warehouseAreaDescr}-{row.rack}-{row.col}-
                              {row.shelf}
                            </li>
                            <li>
                              {row.lastMovData && (
                                <span className="half-parent-text">
                                  {`Ult. mov. ${row.lastMovData}`}
                                </span>
                              )}
                            </li>
                          </ul>
                        </td>
                      </tr>
                      {row.pickingList?.length > 0 &&
                        row.pickingList.map((pickingListItem, pickingListIndex) => (
                          <tr
                            key={`rowPl-${row.id}-${pickingListIndex}`}
                            style={{
                              fontStyle: "italic",
                              opacity: 0.8,
                              verticalAlign: "middle",
                            }}
                          >
                            <td colSpan={4}></td>
                            <td>
                              <ul className="list-unstyled">
                                <li>{pickingListItem.supplierDescr}</li>
                                <li>
                                  <span className="half-parent-text">
                                    {pickingListItem.supplierId}
                                  </span>
                                </li>
                              </ul>
                            </td>
                            <td className="text-end">
                              {pickingListItem.productYear}
                            </td>
                            <td>
                              <div className="d-flex justify-content-between align-items-center">
                                <select
                                  id={`qty-${row.id}-${pickingListItem.id}`}
                                  value={pickingListItem.selectedQty || 0}
                                  onChange={(event) =>
                                    handlePickingListQtyChange(
                                      rowIndex,
                                      pickingListIndex,
                                      event
                                    )
                                  }
                                  className="form-select text-end"
                                  style={{ width: "100px" }}
                                >
                                  {Array.from(
                                    { length: row.qty + 1 },
                                    (_, i) => row.qty - i
                                  ).map((qty) => (
                                    <option key={qty} value={qty}>
                                      {qty}
                                    </option>
                                  ))}
                                </select>
                                &nbsp; / &nbsp;
                                <span>
                                  {DataManager.Decimal.format(
                                    pickingListItem.qty,
                                    0
                                  )}
                                </span>
                              </div>
                            </td>
                            <td>
                              <ul className="list-unstyled">
                                <li>
                                  {pickingListItem.warehouseAreaDescr}-
                                  {pickingListItem.rack}-{pickingListItem.col}-
                                  {pickingListItem.shelf}
                                  {quantities[pickingListItem.keyId]
                                    .selectedQty >
                                  quantities[pickingListItem.keyId].qty ? (
                                    <ErrorIcon className="ms-3 text-danger" />
                                  ) : null}
                                </li>
                                <li>
                                  {pickingListItem.lastMovData && (
                                    <span className="half-parent-text">
                                      {`Ult. mov. ${pickingListItem.lastMovData}`}
                                    </span>
                                  )}
                                </li>
                              </ul>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          title="Salva"
          variant="success"
          onClick={handleSaveModal}
          disabled={pickingList?.some(
            (row) =>
              // row.selected &&
              row.pickingList?.reduce(
                (sum, mov) => sum + Math.abs(mov.selectedQty),
                0
              ) !== row.qty
          )}
        >
          <SaveAltIcon />
        </Button>
        {/* <Button variant="secondary" onClick={closeModal}>
          Chiudi
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEditOutgoings;
